const firebaseConfig = {
    apiKey: "AIzaSyDeCvFblZbzWrCDO8jqqIR2dkmBByuvEbY",
    authDomain: "alpha-care-d0392.firebaseapp.com",
    projectId: "alpha-care-d0392",
    storageBucket: "alpha-care-d0392.appspot.com",
    messagingSenderId: "1088497567093",
    appId: "1:1088497567093:web:849ff70109878889c97f3c"
};

export default firebaseConfig;